import { App, Tag, Tooltip, Typography } from "antd";
import moment from "moment";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
import { BAILIFF_STATUS } from "store/string";
import { useResponsive } from "hook/useResponsive";
import { useNavigate, useParams } from "react-router-dom";
//str
import logo from "config/img/logo.png";
import "./card_document.css";

const CardDocument = ({ data }) => {
  const { message } = App.useApp();
  // -------------------------- VAR -----------------------------
  const { mobile } = useResponsive();
  const navigate = useNavigate();
  const params = useParams();
  const clientId = params.clientId;
  const size = 90;
  const title = data?.name || "";
  const id = data?.id;
  const status = data?.status;
  const createAt = data?.createAt;
  const labelCreate = moment(createAt?.toDate()).format("DD/MM/YYYY");
  const labelTime = mobile ? labelCreate : `${labelCreate}`;
  const label = BAILIFF_STATUS?.find((b) => b?.status === status)?.label;
  const color = BAILIFF_STATUS?.find((b) => b?.status === status)?.color;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleClick = () => {
    const isApproval = status === "approval";
    if (!isApproval)
      return message.info(
        "Chưa thể QC do đang trong quá trình sửa hoặc đã chuyển file cho khách hàng."
      );
    const path = `/client/${clientId}/${id}`;
    navigate(path, { replace: true });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div onClick={handleClick} className="card-document">
      <div className="card-document-feature">
        <img style={{ width: size, height: size }} src={logo} alt="logo" />
      </div>
      <div className="card-document-info">
        <Typography.Text
          ellipsis={{ rows: 1 }}
          style={{ fontSize: 16, fontWeight: 500, color: "black" }}
        >
          {title}
        </Typography.Text>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: mobile ? "column" : "row",
            gap: 5,
          }}
        >
          <div style={{ flex: mobile ? 1 : 0.5 }}>
            <Typography.Text ellipsis={{ rows: 1 }} type="secondary">
              {labelTime}
            </Typography.Text>
          </div>
          <div
            style={{
              flex: mobile ? 1 : 0.5,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Tooltip title={label}>
              <Tag color={color}>{status}</Tag>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardDocument;
